export default __webpack_public_path__ + "static/media/thumb-red.b8414676.svg";